module.exports = __webpack_public_path__ + "img/back-icon.837333d4.svg";